import { CourseRequest } from '@/types'
import { refreshAuthTokenAndUpdateUser } from '@/auth/utils'

const API_URL = import.meta.env.VITE_API_URL

export type ADGroupCheckResult = {
  exists: boolean
  group: { id: string; displayName: string; description?: string; mail?: string } | null
  matchingGroups: { id: string; displayName: string; description?: string; mail?: string }[]
  members: { displayName: string; mail: string }[]
}

export const listMyRequestsFromDB = async (signal: AbortSignal): Promise<CourseRequest[]> => {
  const idToken = await refreshAuthTokenAndUpdateUser()
  const response = await fetch(`${API_URL}/api/requests/my`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${idToken}`,
    },
    signal,
  })

  if (!response.ok) {
    const body = await response.json()
    throw new Error(body.message || 'Failed to fetch request history')
  }

  return response.json()
}

export const checkADGroup = async (groupName: string): Promise<ADGroupCheckResult> => {
  const idToken = await refreshAuthTokenAndUpdateUser()
  const response = await fetch(
    `${API_URL}/api/requests/check-ad-group?group_name=${encodeURIComponent(groupName)}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    },
  )

  if (!response.ok) {
    const body = await response.json()
    throw new Error(body.error || body.message || 'Failed to check AD group')
  }

  return response.json()
}
